export default {
  accreditation_level: 'Nível de acreditação',
  address_line: 'Logradouro',
  administrative_sphere: 'Esfera administrativa',
  aghuse_code: 'Código AGHUse',
  aghuse_integration: 'Integração com AGHUse',
  alternate_phone: 'Telefone alternativo',
  captcha: 'Captcha',
  cell_phone: 'Celular',
  cep: 'CEP',
  cnes: 'CNES',
  complement: 'Complemento',
  confirm_new_passoword: 'Confirmar senha',
  corporate_name: 'Razão social',
  county: 'Município',
  cpf: 'CPF',
  description: 'Descrição',
  district: 'Bairro',
  email: 'E-mail',
  health_region: 'Região de saúde',
  institution_name: 'Nome da instituição',
  main_phone: 'Telefone principal',
  macro_region: 'Macrorregião',
  name: 'Nome',
  new_password: 'Nova senha',
  number: 'Número',
  organization_nature: 'Natureza da organização',
  password: 'Senha',
  profile: 'Perfil',
  search_by_name: 'Pesquisar por nome',
  search_by_procedure_name: 'Pesquisar por nome do procedimento',
  search_by_doc_name: 'Pesquisar por nome do documento',
  search_by_description_or_code: 'Pesquisar por descrição ou código',
  social_name: 'Nome social',
  status: 'Status',
  status_group: 'Grupo de status',
  type_unity: 'Tipo da unidade',
  uf: 'UF',
  unity: 'Unidade',
  unities: 'Unidades',
  unity_responsible: 'Diretor Clínico/Gerente/Administrador',
  unity_attendance: 'Unidade Atendente',
  unity_regulatement: 'Unidade Reguladora',
  unity_assessment: 'Unidade Avaliadora',
  unity_solicitation: 'Unidade Solicitante',
  ppp: 'Solicita Exames de Imagem?',
  egress: 'Solicita Ambulatorial Egresso?',
  unacon: 'Solicita Oncologia (UNACON/CACON)?',
  flag_eletive: 'Solicita Cirurgia Eletiva?',
  types_procedures: 'Tipos de procedimento',
  father_name: 'Nome do pai',
  mother_name: 'Nome da mãe',
  gender: 'Sexo',
  color: 'Cor',
  color_race: 'Raça/Cor',
  marital_status: 'Estado civil',
  nationality: 'Nacionalidade',
  place_of_birth: 'Naturalidade',
  education_level: 'Grau de instrução',
  occupation: 'Ocupação',
  home_phone: 'Telefone residencial',
  additional_phone: 'Telefone adicional',
  naturalized_brazilian: 'Naturalizado brasileiro',
  date_of_entry_brazil: 'Data de entrada no Brasil',
  date_of_naturalization: 'Data de naturalização',
  ordinance: 'Portaria',
  correspondence: 'Correspondência',
  rg: 'RG',
  issuing_authority: 'Órgão emissor',
  date_of_issue: 'Data de emissão',
  date_of_issue_rg: 'Data de emissão (RG)',
  cns: 'CNS',
  mother_cns: 'CNS da mãe',
  documents_presented: 'Documentos apresentados',
  type_of_certificate: 'Tipo de certidão',
  registration: 'Registro',
  registry_office_name: 'Nome do cartório',
  book: 'Livro',
  pages: 'Folhas',
  term: 'Termo',
  birth_certificate_number: 'Número da DN (Documento de Nascimento)',
  date_of_birth: 'Data de nascimento',
  date_of_birth_month_year: 'Data de nascimento (mês e ano)',
  municipality: 'Município',
  type: 'Tipo',
  observations: 'Observações',
  patient_name: 'Nome do paciente',
  patient_cpf: 'CPF do paciente',
  patient_cns: 'CNS do paciente',
  patient_mother_name: 'Nome mãe do paciente',
  patient_cpf_cns: 'CPF ou CNS do paciente',
  ddd: 'DDD',
  code: 'Código',
  doc_name: 'Nome do documento',
  mandatory: 'Obrigatoriedade',
  required: 'Obrigatório',
  protocols: 'Protocolos',
  procedure: 'Procedimento',
  title_attachment: 'Título do anexo',
  upload_attachment: 'Anexo',
  new_attachment: 'Novo anexo',
  protocol_attachments: 'Anexos protocolares',
  others_attachments: 'Outros anexos',
  fill: 'Preenchido',
  pending: 'Pendente',
  cancel_reason: 'Motivo do cancelamento',
  date_solicitation: 'Data de solicitação',
  patient_code: 'Código do paciente',
  patient_record: 'Prontuário do paciente',
  risk_classification: 'Classificação de prioridade',
  solicitacion_status: 'Status da solicitação',
  sent: 'Enviado',
  removed: 'Removido',
  new_observation: 'Nova observação',
  assessment: 'Avaliação',
  urgency: 'Alta',
  medium_urgency: 'Média',
  no_urgency: 'Baixa',
  document: 'Documento',
  bind: 'Vincular',
  search_by_code_or_sub_occupation: 'Pesquisar por código ou sub-ocupação',
  search_by_code_or_description: 'Pesquisar por código ou descrição',
  sub_occupation: 'Sub-ocupação',
  condicao: 'Condição',
  liminar_judicial: 'Liminar Judicial',
  documents: 'Documentos',
  remove: 'Remover',
  gender_identity: 'Identidade de gênero',
  min_age: 'Idade mínima',
  max_age: 'Idade máxima',
  ages: 'Anos',
  months: 'Meses',
  days: 'Dias',
  preparation: 'Preparo',
  notes_instructions: 'Observações/Instruções',
  council: 'Conselho',
  professionals: 'Profissionais',
  type_schedule: 'Tipo de agenda',
  availability: 'Disponibilidade',
  professional: 'Profissional',
  group: 'Grupo',
  visualization: 'Visualização',
  date: 'Data',
  start_hour: 'Hora início',
  end_hour: 'Hora fim',
  available_vacancies: 'Vagas disponíveis',
  time: 'Horário',
  patients_scheduled: 'Pacientes agendados',
  uninformed: 'Não informado',
  protocol: 'Protocolo',
  others: 'Outros',
  occupations: 'Ocupações',
  subOccupations: 'Sub-ocupações',
  repetition: 'Repetição',
  how_many_times: 'Quantidade de vezes?',
  interval: 'Intervalo',
  title: 'Título',
  procedure_group: 'Grupo de procedimentos',
  solicitation_type: 'Tipo de solicitação',
  procedure_type: 'Tipo de procedimento',
  patient_status: 'Status do paciente',
  transport_type: 'Tipo de transporte',
  hospital_sector: 'Setor do hospital',
  latitude: 'Latitude',
  longitude: 'Longitude',
  type_solicitation: 'Tipo de solicitação',
  priority_classification: 'Classificação de prioridade',
  solicitation_date: 'Data da solicitação',
  specialty: 'Especialidade',
  distance: 'Distancia',
  distance_to_unity_for_patient:
    'Distância aproximada da unidade para o paciente',
  vacancy: 'Vaga',
  vacancy_remaining: 'Vaga disponível',
  vacancies: 'Vagas',
  vacancies_remaining: 'Vagas disponíveis',
  patient: 'Paciente',
  hour: 'Hora',
  details: 'Detalhes',
  motive: 'Motivo',
  justification: 'Justificativa',
  health_districts: 'Distritos sanitários',
  health_district: 'Distrito',
  county_or_health_region_or_macro:
    'Município ou Região de saúde ou Macrorregião',
  risk_high: 'Alta prioridade',
  risk_medium: 'Média prioridade',
  risk_low: 'Baixa prioridade',
  clinical_summary: 'Resumo clínico',
  observation: 'Observação',
  sex: 'Sexo',
  biological_sex: 'Sexo biológico',
  motive_change_status: 'Motivo para alteração do status',
  scheduled: 'Agendados',
  attended: 'Atendidos',
  unredeemed: 'Não-atendidos',
  schedule_date: 'Data da agenda',
  age: 'Idade',
  ethnicity: 'Etnia',
  competence: 'Competência',
  initial_date: 'Data Início',
  end_date: 'Data Fim',
  ibge_code: 'Código IBGE',
  expired_patients: 'Pacientes expirados',
  period: 'Período',
  user_cpf: 'Usuário (CPF)',
  action: 'Ação',
  solicitaiton_code: 'Código da solicitação',
  phone_unity_orderer: 'Telefone da unidade solicitante',
  type_protocols: 'Tipo de Protocolo',
  attachment: 'Anexo',
  genders: 'Sexos',
  expired_date: 'Data expirada',
  process_number: 'N° do processo',
  court: 'Vara',
  object: 'Objeto',
  fatal_deadline: 'Prazo fatal',
  decision_device: 'Dispositivo da decisão',
  diagnostic: 'Diagnóstico',
  diagnostics: 'Diagnósticos',
  amount: 'Quantidade',
  patients: 'Pacientes',
  judicial_injunction: 'Liminar judicial',
  has_fatal_deadline: 'Possui prazo fatal?',
  has_limit_of_uses: 'Possui limite de usos?',
  alert_message: 'Mensagem de alerta',
  initial_end_date: 'Data Início e Fim',
  user: 'Usuário',
  value: 'Valor',
  age_range: 'Faixa etária',
  type_of_financing: 'Tipo de financiamento',
  overall_value: 'Valor global',
  contract: 'Contrato',
  publication_date: 'Data de publicação',
  quantity: 'Quantidade',
  version: 'Versão',
  scheduling_date_start: 'Data de início do agendamento',
  scheduling_date_end: 'Data de fim do agendamento',
  schedule_date_start: 'Data de início da agenda',
  schedule_date_end: 'Data de fim da agenda',
  opening_date_start: 'Data de início da abertura',
  opening_date_end: 'Data de fim da abertura',
  attendance_date_start: 'Data de início do atendimento',
  attendance_date_end: 'Data de fim do atendimento',
  search_by_ibge_code_or_name: 'Buscar pelo Código IBGE ou Nome',
  code_ibge: 'Código IBGE',
  lat: 'Latitude',
  lon: 'Longitude',
  cid: 'CID',
  name_procedure: 'Nome do procedimento',
  unity_orderer: 'Unidade solicitante',
  schedule_destination_unity: 'Unidade Agendamento',
  type_of_treatments: 'Tipo de tratamento',
  date_of_treatment_start_chemotherapy:
    'Data de início do tratamento (Quimioterapia)',
  date_of_treatment_start_radiotherapy:
    'Data de início do tratamento (Radioterapia)',
  date_of_treatment_start_surgery: 'Data de início do tratamento (Cirurgia)',
  date_of_treatment_start_immunotherapy:
    'Data de início do tratamento (Imunoterapia)',
  date_of_treatment_start_hormonetherapy:
    'Data de início do tratamento (Hormonioterapia)',
  type_of_treatment: 'Tipo de tratamento',
  date_of_medical_discharge: 'Data da alta médica',
  binded_unity: 'Unidade vinculada',
  attended_out_of_profile: 'Atendida - Fora do Perfil',
  attended_conservative_treatment: 'Atendida - Tratamento Conservador',
  attended_surgical_treatment: 'Atendida - Tratamento Cirurgico',
  attended_awaiting_exams: 'Atendida - Aguardando Exames',
  aprove: 'Aprovar',
  solicitate_adjustment: 'Solicitar ajuste',
  reprove: 'Reprovar',
  initial_outpatient_request: 'Solicita Ambulatorial Inicial?',
  attendance_restriction: 'Restrição de atendimento',
};
